<template>
  <main class="main" role="main">
    <div class="page grey"><!--'로그인, 아이디찾기, 비밀번호찾기: grey'-->
      <div class="inner">
        <div class="page_ttl">
          <h1 class="h1">
            <span>비밀번호 찾기</span>
          </h1>
        </div>
        <div class="page_con">
          <div class="find_id w420">
            <div class="form">
              <ul class="form_ul">
                <li class="form_li">
                  <div class="form_ttl">
                    <p>신규 비밀번호</p>
                  </div>
                  <div class="form_in">
                    <div class="input">
                      <input type="password" placeholder="비밀번호를 입력해 주세요">
                      <p class="valid">유효성 문구 영역</p><!--'on 추가'-->
                    </div>
                  </div>
                </li>
                <li class="form_li">
                  <div class="form_ttl">
                    <p>비밀번호 확인</p>
                  </div>
                  <div class="form_in">
                    <div class="input">
                      <input type="text" placeholder="다시 한 번 입력해 주세요">
                      <p class="valid">유효성 문구 영역</p><!--'on 추가'-->
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="page_btn">
              <button class="btn bo grey">이전으로</button>
              <button class="btn">비밀번호 변경하기</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: 'sign-find-password-step2-index'
}
</script>

<style scoped></style>
